export const styles = {
  upsellContainer: {
    backgroundColor: "events.grayShade2",
    padding: "20px",
    border: "1px solid",
    borderColor: "events.grayShade1",
    borderRadius: "5px",
  },
  upsellHeader: {
    marginBottom: 1.25,
  },
  upsellButton: {
    color: "white",
    textDecoration: "none",
  },
  helpText: {
    marginBottom: 2,
  },
};
